import client from '../client';
import { buildQuery } from '~/utils'
import { exportFile } from '../requestDownloadFile';

export default {
    getProductDetail: id => {
        return client.get(`publisher/product/detail/${id}`).then(res => res.data);
    },
    //没有trackLinkId时，获取商品初始化默认链接信息
    getTrackDetailByProductId: ({ productId, countryCode }) => {
        return client.get(`${productId}/tracking/link/init?countryCode=${countryCode}`).then(res => res.data);
    },
    //没有trackLinkId时，获取品牌初始化默认链接信息
    getTrackDetailByBrandId: ({ brandId, countryCode }) => {
        return client.get(`brand/${brandId}/tracking/link/init?countryCode=${countryCode}`).then(res => res.data);
    },
    //根据trackLinkId获取链接详情信息
    getTrackDetailByTrackLinkId: ({ linkType, trackLinkId }) => {
        return client.get(`${linkType === 'product' ? 'product' : 'brand'}/tracking/link/${trackLinkId}`).then(res => res.data);
    },
    //通过x-Aa-Authorization获取对应publisher 转链工具的source options下拉数据列表
    getSourceOptionsByPublisher: () => {
        return client.get(`publisher/source/list/by-publisher`).then(res => res.data);
    },
    //保存商品链接信息
    saveTrackLink: ({ product, ...configs }) => {
        return client.post(`${productId}/tracking/link/save`, configs).then(res => res.data);
    },
    //参数变化获取商品或品牌链接
    getTrackLinkByParams: ({ linkType, brandId, productId, countryCode, ...data }) => {
        return client.post(`${linkType === 'product' ? productId : 'brand/' + brandId}/tracking/link/by-param?countryCode=${countryCode}`, data).then(res => res.data);
    },
    //新增source option
    addSourceOption: data => {
        return client.post(`publisher/source/save`, data).then(res => res.data);
    },
    //生成trackLink
    saveGenerateLink: (linkType, brandId, productId, countryCode, data) => {
        return client.post(`${linkType === 'product' ? productId : 'brand/' + brandId}/tracking/link/save?countryCode=${countryCode}`, data).then(res => res.data)
    },
    //获取commision history数据
    getCommissionHistoryByProductId: productId => {
        return client.get(`publisher/product/commissionHistory?id=${productId}`, productId).then(res => res.data)
    },
    // 获取associate commision history数据
    getAssociateCommissionHistoryByProductId: brandId => {
        return client.get(`publisher/product/associate/commissionHistory?id=${brandId}`, { params: { brandId } }).then(res => res.data)
    },
    // 获取product variations
    getProductVariations: (id, userType = 'publisher', data) => {
        return client.get(`${userType}/product/${id}/variations/list?${Object.keys(data).map(key => {
            return `${key}=${data[key]}`
        }).join('&')}`).then(res => res.data)
    },
    // Publisher 获取Associate 商品link列表
    getAssociateLinkList: (data) => {
        return client.get(`publisher/product/associate-link/list?${buildQuery(data)}`).then(res => res.data)
    },
    // 初始化associate link
    initAssociateLink: (data) => {
        return client.get(`publisher/product/associate-link/${data.productId}/tracking/link/init`, { params: data }).then(res => res.data)
    },
    //Publisher 参数变化获取商品链接
    getAssociateLinkByParams: (data) => {
        return client.post(`publisher/product/associate-link/${data.productId}/tracking/link/by-param`, data).then(res => res.data)
    },
    // 保存associate link
    saveAssociateLink: (data) => {
        return client.post(`publisher/product/associate-link`, data).then(res => res.data)
    },
    // 导出商品变体
    exportVariations: (data) => {
        return exportFile(`publisher/product/${data.id}/variations/export`, data.qs, data.fileName)
    },
    //获取用户搜索获取上次查询参数 history
    getSearchParamsHistory: (data) => {
        return client.get(`publisher/product/last-query-params`, { params: data }).then(res => res.data)
    }
}